import cx from 'classnames';

interface SingleContentProps {
  content: React.ReactNode;
  isOverflowHidden?: boolean;
}

const SingleContent = ({ content, isOverflowHidden = false }: SingleContentProps): React.ReactElement => {
  return (
    <div
      className={cx('py-4 px-14', {
        'overflow-hidden': isOverflowHidden,
      })}
    >
      {content}
    </div>
  );
};

export default SingleContent;
